const FETCH_USERS = "app/admin/FETCH_USERS";
const SET_USERS = "app/admin/SET_USERS";
const FETCH_CONTROLLERS = "app/admin/FETCH_CONTROLLERS";
const SET_CONTROLLERS = "app/admin/SET_CONTROLLERS";
const FETCH_USER_CONTROLLERS = "app/admin/FETCH_USER_CONTROLLERS";
const SET_USER_CONTROLLERS = "app/admin/SET_USER_CONTROLLERS";
const UPDATE_OTA = "app/admin/UPDATE_OTA";
const SET_OTA = "app/admin/SET_OTA";
const ADD_CONTROLLER = "app/admin/ADD_CONTROLLER";
const SET_NEW_CONTROLLER = "app/admin/SET_NEW_CONTROLLER";
const UPDATE_CONTROLLER = "app/admin/UPDATE_CONTROLLER";
const SET_UPDATE_CONTROLLER = "app/admin/SET_UPDATE_CONTROLLER";
const FETCH_INVOICE = "app/admin/FETCH_INVOICE";
const SET_INVOICE = "app/admin/SET_INVOICE";
const FACTORY_RESET = "app/admin/FACTORY_RESET";

export {
  FETCH_USERS,
  SET_USERS,
  FETCH_CONTROLLERS,
  SET_CONTROLLERS,
  FETCH_USER_CONTROLLERS,
  SET_USER_CONTROLLERS,
  UPDATE_OTA,
  SET_OTA,
  ADD_CONTROLLER,
  SET_NEW_CONTROLLER,
  UPDATE_CONTROLLER,
  SET_UPDATE_CONTROLLER,
  FETCH_INVOICE,
  SET_INVOICE,
  FACTORY_RESET,
};
